//backend
export const baseUrl = "https://rentify-presidio-1.onrender.com";

// export const baseUrl = "http://localhost:3001";

